import { AxiosResponse, HttpStatusCode } from "axios";
import ExternalAuthTokenHelper from "helpers/ExternalAuthTokenHelper";
import { CurrentUser } from "models/auth/CurrentUser";
import { CurrentUserData } from "models/auth/types";
import { useCurrentUserDispatch } from "providers/CurrentUserProvider";
import { CurrentUserAction } from "providers/currentUserReducer";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function useUserInfoResponseHandler(): (
	response: AxiosResponse<CurrentUserData>
) => void {
	const dispatch = useCurrentUserDispatch();
	const navigate = useNavigate();
	return useCallback(
		(response: AxiosResponse<CurrentUserData>) => {
			if (
				response.status !== HttpStatusCode.Ok &&
				response.status !== HttpStatusCode.Accepted
			) {
				toast.error("Erro no login! Entre em contato com o nosso suporte");
				return;
			}

			const { data } = response;
			const user = new CurrentUser(data);
			dispatch?.({
				type: CurrentUserAction.LOGIN,
				user
			});
			ExternalAuthTokenHelper.removeExternalAuthToken();
			const userCompletedRegistration = response.status === HttpStatusCode.Ok;
			const navigateDestination = userCompletedRegistration ? "/" : "/cadastro";
			navigate(navigateDestination);
		},
		[dispatch, navigate]
	);
}
